// Environment Configuration
// This file centralizes all environment variables for the admin frontend

export const config = {
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
    timeout: 30000,
  },

  // API URL for uploads and media access
  API_URL:
    process.env.REACT_APP_API_URL?.replace("/api", "") ||
    "http://localhost:5000",

  // Application Configuration
  app: {
    name: process.env.REACT_APP_APP_NAME || "Putra Mandiri Admin",
    version: process.env.REACT_APP_APP_VERSION || "1.0.0",
  },

  // Development Configuration
  development: {
    debug: process.env.REACT_APP_DEBUG === "true",
    logLevel: process.env.REACT_APP_LOG_LEVEL || "info",
  },

  // Upload Configuration
  upload: {
    maxFileSize: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || "5242880"), // 5MB default
    allowedFileTypes: (
      process.env.REACT_APP_ALLOWED_FILE_TYPES ||
      "image/jpeg,image/png,image/gif,image/webp"
    ).split(","),
  },

  // Pagination Configuration
  pagination: {
    defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "10"),
    maxPageSize: parseInt(process.env.REACT_APP_MAX_PAGE_SIZE || "100"),
  },

  // Authentication Configuration
  auth: {
    sessionTimeout: parseInt(
      process.env.REACT_APP_SESSION_TIMEOUT || "3600000"
    ), // 1 hour default
    refreshTokenInterval: parseInt(
      process.env.REACT_APP_REFRESH_TOKEN_INTERVAL || "300000"
    ), // 5 minutes default
  },
};

// Helper functions for environment variables
export const isDevelopment = () => process.env.NODE_ENV === "development";
export const isProduction = () => process.env.NODE_ENV === "production";
export const isTest = () => process.env.NODE_ENV === "test";

// Validation function to ensure required environment variables are set
export const validateEnvironment = () => {
  const requiredVars = ["REACT_APP_API_URL"];

  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    console.warn("Missing required environment variables:", missingVars);
    console.warn("Using default values. Please check your .env file.");
  }

  return missingVars.length === 0;
};

// Export default config
export default config;
